import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import useDidMountEffect from "../utils/useDidMountEffect";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import apiPlatform from "../apiPlatform";
import CreatableSelect from "react-select/creatable";
import {isEqual} from "lodash";
import getWorkshopSetting from "../utils/getWorkshopSetting";

export const TYPE_VEHICLE_CAR_ID = 1;

const CarTypeSelect = props => {
  const selectRef = React.useRef();
  const [value, setValue] = React.useState(props.value);
  const [carTypes, setCarTypes] = React.useState([]);

  useDidMountEffect(() => {
    if(props.menuIsOpen){
      selectRef.current.focus();
    }

    loadCarTypes()
  })

  useAfterUpdateEffect(() => {
    if(props.isMulti){
      props.onChange(carTypes.filter(carType => value.includes(carType.id)))
    }else{
      props.onChange(carTypes.find(carType => carType.id === value))
    }
  }, [value])

  useAfterUpdateEffect(() => {
    if(!isEqual(props.value, value)){
      setValue(props.value)
    }
  }, [props.value])

  const loadCarTypes = () => apiPlatform.carTypes.list()
    .then(({data}) => setCarTypes(data['hydra:member']))

  const getOptions = () => {
    let options = carTypes.map(carType => ({
      value: carType.id,
      label: carType.name,
    }))

    if(!props.displayAllOptions){
      options = options.filter(option => getWorkshopSetting('vehicle.carTypes').includes(option.value))
    }

    return options
  }

  const SelectComponent = props.isCreateable ? CreatableSelect : Select

  return (
    <SelectComponent
      isMulti={props.isMulti}
      isSearchable={props.isCreateable}
      closeMenuOnSelect={!props.isMulti}
      onCreateOption={name => {
        apiPlatform.carTypes.create({
          name,
        }).then(({data}) => loadCarTypes().then(() => setValue([
            ...value,
            data.id,
          ]))
        )
      }}
      formatCreateLabel={name => <span><i className="fas fa-plus" /> Utwórz: {name}</span>}
      isClearable={false}
      classNamePrefix="react-select"
      className="w-100"
      menuPortalTarget={document.body}
      ref={selectRef}
      noOptionsMessage={() => <span>Brak</span>}
      menuIsOpen={props.menuIsOpen || undefined}
      options={getOptions()}
      placeholder={props.placeholder}
      onBlur={props.onBlur}
      onChange={option => {
        setValue(
          props.isMulti
            ? option.map(({value}) => value)
            : option.value
        )
      }}
      value={props.isMulti ? value.map(carTypeId => getOptions().find(option => option.value === carTypeId)) : getOptions().find(option => option.value === value)}
    />
  );
};

CarTypeSelect.defaultProps = {
  value: null,
  menuIsOpen: false,
  placeholder: 'Wybierz',
  isMulti: false,
  isCreateable: false,
};

CarTypeSelect.propTypes = {
  isMulti: PropTypes.bool,
  isCreateable: PropTypes.bool,
  value: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  menuIsOpen: PropTypes.bool,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

export default CarTypeSelect;
